module.exports = __webpack_public_path__ + "img/solution_subsystem_01@2x.351e55d6.png";